import React, { PropTypes } from 'react';
import NodeChild from './NodeChild';

const NodeChildren = ({ node, children, ...rest }) => {
  if (children.length) {
    return (
      <table className="ui very basic table">
        <tbody>
          {children.map(node => (
            <NodeChild
              key={node.id}
              {...rest}
              node={node}
              nodeCount={children.length}
            />
          ))}
        </tbody>
      </table>
    );
  }

  return <div className="ui message">Aucun noeud. Veuillez en ajouter un.</div>;
};

NodeChildren.propTypes = {
  node: PropTypes.object.isRequired,
  children: PropTypes.array.isRequired,
};

export default NodeChildren;



// WEBPACK FOOTER //
// ./src/modules/catalog/components/NodeChildren.js